package com.sweetlime.bingeamigo.presentation.features.tvdetail

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.model.Episode
import com.sweetlime.bingeamigo.model.TvShow

data class EpisodeDetailScreen(
    // TvShow primitives
    val tvShowId: Int,
    val tvShowName: String,
    val tvShowOverview: String = "",
    val tvShowAdult: Boolean = false,
    val tvShowBackdropPath: String? = null,
    val tvShowPosterPath: String? = null,
    val tvShowOriginalLanguage: String = "",
    val tvShowOriginalName: String = "",
    val tvShowPopularity: Double = 0.0,
    val tvShowFirstAirDate: String = "",
    val tvShowVoteAverage: Double = 0.0,
    val tvShowVoteCount: Int = 0,
    // Episode primitives
    val episodeId: Int,
    val episodeName: String,
    val episodeOverview: String = "",
    val episodeAirDate: String = "",
    val episodeNumber: Int,
    val episodeSeasonNumber: Int,
    val episodeStillPath: String? = null,
    val episodeVoteAverage: Double = 0.0,
    val episodeRuntime: Int? = null,
    // Other
    val totalEpisodesInShow: Int
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val tvShow = TvShow(
            id = tvShowId,
            name = tvShowName,
            overview = tvShowOverview,
            adult = tvShowAdult,
            backdropPath = tvShowBackdropPath,
            posterPath = tvShowPosterPath,
            originalLanguage = tvShowOriginalLanguage,
            originalName = tvShowOriginalName,
            popularity = tvShowPopularity,
            firstAirDate = tvShowFirstAirDate,
            voteAverage = tvShowVoteAverage,
            voteCount = tvShowVoteCount
        )
        val episode = Episode(
            id = episodeId,
            name = episodeName,
            overview = episodeOverview,
            airDate = episodeAirDate,
            episodeNumber = episodeNumber,
            seasonNumber = episodeSeasonNumber,
            stillPath = episodeStillPath,
            voteAverage = episodeVoteAverage,
            runtime = episodeRuntime
        )
        EpisodeDetailContent(
            tvShow = tvShow,
            episode = episode,
            totalEpisodesInShow = totalEpisodesInShow,
            onBackClick = { navigator.pop() }
        )
    }
}

fun EpisodeDetailScreen(
    tvShow: TvShow,
    episode: Episode,
    totalEpisodesInShow: Int
) = EpisodeDetailScreen(
    tvShowId = tvShow.id,
    tvShowName = tvShow.name,
    tvShowOverview = tvShow.overview,
    tvShowAdult = tvShow.adult,
    tvShowBackdropPath = tvShow.backdropPath,
    tvShowPosterPath = tvShow.posterPath,
    tvShowOriginalLanguage = tvShow.originalLanguage,
    tvShowOriginalName = tvShow.originalName,
    tvShowPopularity = tvShow.popularity,
    tvShowFirstAirDate = tvShow.firstAirDate,
    tvShowVoteAverage = tvShow.voteAverage,
    tvShowVoteCount = tvShow.voteCount,
    episodeId = episode.id,
    episodeName = episode.name,
    episodeOverview = episode.overview,
    episodeAirDate = episode.airDate,
    episodeNumber = episode.episodeNumber,
    episodeSeasonNumber = episode.seasonNumber,
    episodeStillPath = episode.stillPath,
    episodeVoteAverage = episode.voteAverage,
    episodeRuntime = episode.runtime,
    totalEpisodesInShow = totalEpisodesInShow
)